"use strict";

exports.__esModule = true;
exports.NotificationsPanel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NotificationsIconContext = require("./NotificationsIconContext");
var _NotificationDetails = require("./NotificationDetails");
var _reactIntl = require("react-intl");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var NotificationsPanel = exports.NotificationsPanel = function NotificationsPanel() {
  var notificationsIconContext = (0, _react.useContext)(_NotificationsIconContext.NotificationsIconContext);
  var _ref = notificationsIconContext || {},
    notifications = _ref.notifications,
    readNotification = _ref.readNotification;
  return notifications ? notifications == null ? void 0 : notifications.map(function (notification, index) {
    return /*#__PURE__*/_react["default"].createElement(_NotificationDetails.NotificationDetails, {
      key: index,
      notification: notification,
      index: index,
      readNotification: readNotification
    });
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: "center",
      marginTop: "15px",
      marginBottom: "15px"
    }
  }, " ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "NotificationsPanel.label.NoNewMessages",
    defaultMessage: "No new messages"
  }));
};